<template>
  <div id="not-found">
    <h1>指定されたページは存在しません．</h1>
    <p id="home-route" v-on:click="goHome"><u>ホームへ</u></p>
  </div>
</template>
<script>
export default {
  name: 'room',
  methods: {
    goHome() {
      // if (this.socket){this.socket.close()}
      // this.$store.commit('clearUserInfo')
      // this.$store.commit('clearGameInfo')
      // this.$store.commit('clearMissionInfo')
      // this.$store.commit('clearUserList')
      this.$router.push({ name: 'Home', params: {}})
    }
  }
}
</script>
<style>
#not-found {
  margin-top: 64px;
}
#not-found #home-route {
  margin-top: 32px;
  color: #5555BB;
  cursor:pointer;
}
</style>
